import FalconComponentCard from "components/common/FalconComponentCard";
import { Button, Col, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { MdAdd } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import PractitionersListFilters from "./components/PractitionersListFilters";
import PractitionersListTable from "./components/PractitionersListTable";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import paths from "routes/paths";
import {
  handlePractitonerFilter,
  handlePractitonerReset,
} from "./config/practitionerSlice";
import { GetAllPractitionerList } from "./config/practitionerSliceAPi";
import { toast } from "react-toastify";
import { FiDownloadCloud } from "react-icons/fi";
import { handleDownloadXLSX } from "helpers/excel";
import moment from "moment";

const Practitioners = () => {
  const dispatch = useDispatch();

  const { practitionerFilters, practitionerListData } = useSelector(
    (state) => state.practitioner
  );

  const { allPermissionType } = useSelector((state) => state.role);
  const practitonerSetting = allPermissionType?.[0]?.rolemngmt_name?.find(
    (item) => item?.rolemngmttyp_name === "Practitioner"
  );
  const selectedBranch = JSON.parse(localStorage.getItem("selectedBranch"));
  const { control, watch, handleSubmit, setValue, reset } = useForm({
    defaultValues: {
      branch: "",
      name: "",
      license_number: "",
      speciality: "",
      id_number: "",
    },
  });

  const navigate = useNavigate();

  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const requestBody = (customPage = page, customLimit = rowsPerPage) => ({
    branch_id:
      practitionerFilters?.branch?.branch_id ||
      selectedBranch?.branch_id ||
      selectedBranch?.value ||
      "",
    pract_name: practitionerFilters?.name || "",
    pract_natid: practitionerFilters?.id_number || "",
    pract_lcnno: practitionerFilters?.license_number || "",
    specialities_code: practitionerFilters?.speciality?.specialities_code || "",
    start_point: customPage,
    limit: customLimit,
  });

  const handlePageChange = useCallback((newPage) => {
    setPage(newPage);
  }, []);

  const handlePerRowsChange = useCallback((newPerPage) => {
    setRowsPerPage(newPerPage);
    setPage(0); // Reset to first page when changing page size
  }, []);

  const fetchPractitionerList = async (body = {}) => {
    try {
      const response = await dispatch(GetAllPractitionerList(body)).unwrap();
      setTotalRows(response?.total_rows || 0);
    } catch (error) {
      toast.error("Something Went Wrong");
    }
  };

  useEffect(() => {
    const body = requestBody(page, rowsPerPage);
    fetchPractitionerList(body);
  }, [page, rowsPerPage]);

  const handleCheckListFilter = () => {
    const newPage = 0;
    setPage(newPage); // Reset page
    const body = requestBody(newPage, rowsPerPage);
    fetchPractitionerList(body);
  };
  const handleReset = async () => {
    const body = {
      branch: "",
      name: "",
      license_number: "",
      speciality: "",
      id_number: "",
      start_point: 0,
      limit: 10,
    };
    reset();
    setPage(0);
    setRowsPerPage(10);
    setValue("name", "");

    dispatch(handlePractitonerReset());
    dispatch(handlePractitonerFilter({ check: "name", value: "" }));

    const resetBody = requestBody(0, 10); // Fresh filters
    await fetchPractitionerList(body);
  };

  const handleDownloadExcel = async () => {
    const excelBody = requestBody(page, totalRows);
    await fetchPractitionerList(excelBody);

    const flattenedArray =
      practitionerListData &&
      practitionerListData.length > 0 &&
      practitionerListData.map((row, index) => [
        page * rowsPerPage + index + 1 || "",
        row?.practitioner_license || "", // ✅ Added License No
        row?.practitioner_license_exp || "",
        row?.practitioner_firstname || "", // ✅ Fixed typo from "fisrtname"
        row?.practitioner_familyname || "",
        row?.practitioner_firstname_arabic || "",
        row?.practitioner_familyname_arabic || "",
        row?.practitioner_gender || "",
        row?.practitioner_maritalstatus || "",
        row?.practitioner_nationality || "",
        row?.practitioner_nationalid || "",
        row?.specialities_name || "",
        row?.practitioner_emailid || "", // ✅ Fixed wrong property name
        row?.branch_id || "",
      ]);

    handleDownloadXLSX(
      [
        [
          "No.",
          "License No.",
          "License Exp Date",
          "First Name",
          "Last Name",
          "First Name (Arabic)",
          "Last Name (Arabic)",
          "Gender",
          "Marital Status",
          "Nationality",
          "ID",
          "Specialities",
          "Email",
          "Branch",
        ],
        ...(flattenedArray || []), // ✅ Correctly spread the data
      ],
      `Practitioner_Report_${moment().format("DD-MM-YYYY_hh:mm:ss")}`
    );
  };

  return (
    <>
      {Number(practitonerSetting?.list) === 1 ? (
        <Form
          noValidate
          onSubmit={handleSubmit(handleCheckListFilter)}
          className="p-0"
        >
          <FalconComponentCard
            className="shadow-md"
            style={{ position: "relative" }}
          >
            <FalconComponentCard.Header
              className="d-flex  fixed-header justify-content-between align-items-center"
              sx={{
                position: "sticky !important",
                top: 68,
                zIndex: 1020,
                backgroundColor: "white",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              }}
            >
              <Col xs="auto m-0">
                <h5 className="text-primary mb-0 fs-10">Practitioner</h5>
              </Col>
              <Col xs="auto" className="d-flex gap-2">
                <Button size="sm" variant="outline-danger" onClick={handleReset}>
                  Reset
                </Button>
                <Button
                  type="submit"
                  size="sm"
                  variant="success"
                  onClick={handleSubmit(handleCheckListFilter)}
                >
                  Filter
                </Button>
                {Number(practitonerSetting?.add) === 1 && (
                  <Button
                    size="sm"
                    variant="secondary"
                    onClick={() => navigate(paths.addPractitionerList)}
                  >
                    <MdAdd />
                    New
                  </Button>
                )}
                {Number(practitonerSetting?.export) === 1 && (
                  <Button
                    size="sm"
                    variant="warning"
                    onClick={handleDownloadExcel}
                    className="d-flex align-items-center gap-1"
                  >
                    <FiDownloadCloud size={16} />
                    Excel
                  </Button>
                )}
              </Col>
            </FalconComponentCard.Header>
            <FalconComponentCard.Body
              style={{
                marginTop: "40px", // Adjust this value based on header height
                overflowY: "auto",
                maxHeight: "calc(100vh - 200px)", // Adjust based on your needs
              }}
            >
              <PractitionersListFilters
                watch={watch}
                control={control}
                setValue={setValue}
              />
              <PractitionersListTable
                data={practitionerListData}
                totalRows={totalRows}
                handlePageChange={handlePageChange}
                handlePerRowsChange={handlePerRowsChange}
                page={page}
                setting={practitonerSetting}
                rowsPerPage={rowsPerPage}
              />
            </FalconComponentCard.Body>
          </FalconComponentCard>
        </Form>
      ) : (
        <div className="py-6 text-center border rounded-3mb-3">
          <h5 className="text-danger">Permission Denied</h5>
          <p className="text-muted fs-11">
            You do not have permission to view Practitioner.
          </p>
        </div>
      )}
    </>
  );
};

export default Practitioners;
